<template>
  <div id="organisation-page">
    <div class="subscription-alert" v-if="overview && overview.currentPlan == null">{{$t("organisation.subscriptionAlert")}}</div>
    <OrganisationTabBar />

    <div class="page-content">
      <div class="content-wrapper">
        <vue-page-transition name="fade">
          <router-view></router-view>
        </vue-page-transition>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import slugify from "slugify";
import OrganisationTabBar from "@/components/OrganisationTabBar";

import $ from "jquery";

export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.organisation")
    };
  },
  components: { OrganisationTabBar },
  name: "Organisation",

  data() {
    return {
      loading: false,
      title: null
    };
  },

  methods: {},

  mounted() {},

  async created() {
    await this.$store.dispatch("getOrganization");
    await this.$store.dispatch("getSubscriptionOverview")
  },
  computed: {
    overview(){
      return this.$store.getters.getSubscriptionOverview;
    },
  }
};
</script>

<style lang="less">
#organisation-page {
  width: 100%;
  .page-content {
    width: 100% !important;
  }

  .subscription-alert {
    background: #ff6565;
    padding: 5px;
    border-radius: 10px;
    margin: 20px 10px 0px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    min-height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Organisation.vue